// Entrega/recepción de salidas y compras GT: cambio de origen de línea,
// checklist de picking persistente, y borrado de línea sin alert() ni
// confirm() nativos.
import { post, del } from "./api"
import { toast } from "./toast"

export function initDelivery() {
  initLineSource()
  initPicking()
  initLineDelete()
}

// --- selector de origen (Master/GT/Zona Franca) -----------------------------
//
// Reescribe el jQuery inline que vivía en internal_orders/show_mobile.html.erb.
// El servidor sigue siendo la única fuente de verdad de qué se puede cambiar:
// este select sólo se renderiza para quien entrega (sin `?code=`), nunca para
// el receptor — ver el comentario en la vista.
function initLineSource() {
  document.querySelectorAll("[data-line-source]").forEach((select) => {
    select.dataset.original = select.value

    select.addEventListener("change", async () => {
      const newCompany = select.value
      if (newCompany === select.dataset.original || newCompany === "") {
        select.value = select.dataset.original
        return
      }

      select.disabled = true
      const { ok, data, networkError } = await post(select.dataset.url, {
        line_id: select.dataset.lineId,
        company: newCompany,
      })
      select.disabled = false

      if (networkError) {
        toast("No se pudo actualizar el origen: revisá la señal y volvé a intentar.", "error")
        select.value = select.dataset.original
        return
      }

      if (!ok || !data?.ok) {
        toast(data?.errors?.join(", ") || "No se pudo actualizar el origen.", "error")
        select.value = select.dataset.original
        return
      }

      toast(data.message || "Origen actualizado", "success")
      select.dataset.original = data.source
      // Las opciones "Mixto"/"Sin reserva" sólo tenían sentido mientras no se
      // había elegido un origen único: ya se resolvió, se quitan.
      select.querySelectorAll('option[value=""], option[value="mixto"]').forEach((o) => o.remove())
    })
  })
}

// --- checklist de picking (persistente en localStorage) ---------------------
//
// Antes: <input type="checkbox" id="chequeado"> repetido en cada fila (id
// duplicado, sin name) — no persistía nada. Ahora sobrevive a un refresh de
// página y a que el webview de Telegram recargue la vista.
function initPicking() {
  const list = document.querySelector("[data-picking-list]")
  if (!list) return

  const storageKey = `picking:salida:${list.dataset.orderId}`
  const checked = readPicking(storageKey)

  list.querySelectorAll("[data-picking-check]").forEach((input) => {
    if (checked.includes(input.dataset.lineId)) input.checked = true

    input.addEventListener("change", () => {
      let current = readPicking(storageKey)
      current = input.checked
        ? [...new Set([...current, input.dataset.lineId])]
        : current.filter((id) => id !== input.dataset.lineId)
      writePicking(storageKey, current)
    })
  })
}

function readPicking(key) {
  try {
    return JSON.parse(localStorage.getItem(key) || "[]")
  } catch (_e) {
    // Storage bloqueado (algunos webviews de Telegram lo restringen): el
    // picking simplemente no persiste, pero la pantalla sigue funcionando.
    return []
  }
}

function writePicking(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value))
  } catch (_e) {
    // Igual que arriba: fallar en silencio, no romper el flujo de entrega.
  }
}

// --- borrado de línea con confirmación propia (sin confirm() nativo) --------

function initLineDelete() {
  document.querySelectorAll("[data-delete-line]").forEach((button) => {
    button.addEventListener("click", () => {
      openConfirmSheet({
        title: button.dataset.confirmText || "¿Eliminar esta línea?",
        confirmLabel: "Eliminar",
        onConfirm: async () => {
          const { ok, networkError } = await del(button.dataset.url)
          if (networkError) {
            toast("No se pudo eliminar: revisá la señal.", "error")
            return
          }
          if (!ok) {
            toast("No se pudo eliminar la línea.", "error")
            return
          }
          const row = document.getElementById(button.dataset.rowId)
          if (row) row.remove()
          toast("Línea eliminada", "success")
        },
      })
    })
  })
}

function openConfirmSheet({ title, confirmLabel, onConfirm }) {
  const overlay = document.createElement("div")
  overlay.className = "m-sheet-overlay"
  overlay.innerHTML = `
    <div class="m-sheet">
      <div class="m-sheet__title"></div>
      <div class="m-sheet__actions">
        <button type="button" class="m-btn m-btn--ghost" data-cancel>Cancelar</button>
        <button type="button" class="m-btn m-btn--danger" data-confirm></button>
      </div>
    </div>
  `
  overlay.querySelector(".m-sheet__title").textContent = title
  overlay.querySelector("[data-confirm]").textContent = confirmLabel

  const close = () => overlay.remove()
  overlay.addEventListener("click", (e) => {
    if (e.target === overlay) close()
  })
  overlay.querySelector("[data-cancel]").addEventListener("click", close)
  overlay.querySelector("[data-confirm]").addEventListener("click", async () => {
    close()
    await onConfirm()
  })

  document.body.appendChild(overlay)
}
